// const POLYFILL_MODULE = 'core';
import './svg4everybody/async-load__svg4everybody';
import 'babel-polyfill';




// WEBPACK FOOTER //
// ./client/src/core/polyfills/index.js